<script lang="ts" setup>

//vue
import { onMounted, reactive, watch } from "vue";

//servicos
import * as service from "@/services/BoletosService";
import { f2dec} from "@/utils/funcoes";

//componentes
import MsgBox from "@/components/MsgBox/Index.vue";
import TextBox from "@/components/TextBox/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import DropdownParamBoleto from "@/components/Dropdowns/DropdownParamBoleto.vue";
import Loading from "@/components/Loading/index.vue";

interface IProps {
    exibir: boolean
}

var props = defineProps<IProps>();

var emit = defineEmits(["gerou","erro", "fechou"]);

var controle = reactive({ 
    
    janGerarBoletos: false,
    param: {
        paramBoletoId: 1,
        
    } as service.GerarBoletoFiltros,


    loading: false,
    status: "",
    erro: ""
});


watch(() => props.exibir, async (novoValor) => {

    controle.janGerarBoletos = novoValor;

    if (controle.janGerarBoletos == true)
    {
        setTimeout(() => {
            var jan = document.getElementById("janGerarBoletos");
            var el = jan?.querySelector("#inputFocus") as HTMLInputElement;
            if (el != undefined)
                el.focus();
        }, 700);
    }

})

async function gerar(){

    controle.erro = "";
    controle.status = "";
    controle.loading = true;

    controle.status = `Gerando boletos ...`;

    await service.gerarBoletos(controle.param)
    .then(r=> {
        controle.status =  `OK`;
        emit("gerou");

        setTimeout(() => {
            controle.loading = false;
            fechar();
        }, 4000);

        controle.janGerarBoletos = false;
    })  
    .catch((erro) => {
        controle.erro = erro;
        controle.status = "Erro: " + erro ;
        controle.loading = false;
        emit("erro", erro);
    });
}

function fechar() {
    controle.janGerarBoletos = false;
    emit("fechou");
}


</script>



<template>
    <Loading :isLoading="controle.loading" :mensagem="controle.status" />

    <MsgBox :id="'janGerarBoletos'" :titulo="'Gerar Boletos'"  :exibir="controle.janGerarBoletos"  @onFechou="controle.janGerarBoletos = false" >
        <TrataTecla>

             <div class="row mb-2">
                <div class="col-md-2">
                    Convênio
                </div>
                <div class="col-md-10">
                    <DropdownParamBoleto v-model="controle.param.paramBoletoId" id="inputFocus  "/>
                </div>
            </div>
            
            <div class="row mb-2" >
                <div class="col-md-2">
                    <label>Usuário</label>
                </div>
                <div class="col-md-4">
                     <input type="text" class="form-control form-control-sm" v-model="controle.param.nomeUsuario" id="nomeUsuario" ref="nomeUsuario">
                </div>
            </div>

            <div class="row mb-2" >
                <div class="col-md-2">
                      <label>Senha</label>
                </div>
                <div class="col-md-4">
                    <input type="password" class="form-control form-control-sm" v-model="controle.param.senha" ref="senha" >
                </div>
            </div>

            <div class="row mb-2">
                <div class="col-md-12 fw-bold">
                    Informe o período das mensalidades que deseja gerar boletos
                </div>
            </div>

            <div class="row mb-2" >
                <div class="col-md-2">
                    <label>Data Inicial</label>
                </div>
                <div class="col-md-4">
                     <input type="date" class="form-control form-control-sm" v-model="controle.param.dataInicial" id="dataInicial" ref="dataInicial">
                </div>
            </div>

            <div class="row mb-2" >
                <div class="col-md-2">
                    <label>Data Final</label>
                </div>
                <div class="col-md-4">
                     <input type="date" class="form-control form-control-sm" v-model="controle.param.dataFinal" id="dataFinal" ref="dataFinal">
                </div>
            </div>

            <div class="row mb-2">
                <div class="col-md-12 fw-bold">
                    Informe a data de vencimento que será atribuída aos boletos gerados
                </div>
            </div>

            <div class="row mb-2" >
                <div class="col-md-2">
                    <label>Data Vencimento</label>
                </div>
                <div class="col-md-4">
                     <input type="date" class="form-control form-control-sm" v-model="controle.param.dataVencimento" id="dataVencimento" ref="dataVencimento">
                </div>
            </div>

           

            <div class="row" v-if="controle.erro != ''">
                <div class="col-md-2"></div>
                <div class="col-md-10 fw-bold text-danger">
                    {{controle.erro}}
                </div>
            </div>

            <div class="row" v-if="controle.status != '' && controle.erro == ''">
                <div class="col-md-3"></div>
                <div class="col-md-9 fw-bold ">
                    <i class="fa fa-cog fa-spin"></i> {{controle.status}}
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <hr>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <button type="button" class="btn btn-primary btn-sm" @click="gerar()" :disabled="controle.loading">Gerar</button>
                </div>
                <div class="col-md-6">
                    <a class="btn btn-secondary btn-sm float-end" @click="fechar()" :disabled="controle.loading">Fechar</a>
                </div>
            </div>
        </TrataTecla>
    </MsgBox>
</template>